// Widget "Alertas clínicas" del Dashboard (Rediseño mayor 2026-09-01) —
// alergias activas + resultados de laboratorio anormales de los pacientes
// con cita HOY (GET /api/hce/dashboard-hoy, lib/hce-dashboard.ts en
// packages/web). Datos reales, no un placeholder — si no hay ninguna
// alerta, el widget lo dice en vez de desaparecer sin explicación.
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import type { AlertaClinica } from '@/lib/hceVault';

export function AlertasClinicas({ alertas }: { alertas: readonly AlertaClinica[] }): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="rounded-lg border border-border bg-card p-3">
      <h2 className="text-sm font-medium text-hce-ink">{t('dashboard.alertas.titulo')}</h2>
      {alertas.length === 0 ? (
        <p className="mt-2 text-xs text-hce-muted">{t('dashboard.alertas.sinAlertas')}</p>
      ) : (
        <ul className="mt-2 space-y-2">
          {alertas.map((alerta, i) => (
            <li key={`${alerta.patientId}-${i}`} className="flex items-start gap-2">
              <span
                aria-hidden="true"
                className={`mt-1.5 size-1.5 shrink-0 rounded-full ${alerta.tipo === 'alergia' ? 'bg-destructive' : 'bg-amber-500'}`}
              />
              <div className="min-w-0">
                <div className="truncate text-sm text-hce-ink">{alerta.detalle}</div>
                <button type="button" onClick={() => void navigate(`/${alerta.patientId}`)} className="truncate text-xs text-hce-pine hover:underline">
                  {alerta.patientName}
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
